import { render, staticRenderFns } from "./CarBattery2.vue?vue&type=template&id=6c34d4d9&scoped=true&"
import script from "./CarBattery2.vue?vue&type=script&lang=js&"
export * from "./CarBattery2.vue?vue&type=script&lang=js&"
import style0 from "./CarBattery2.vue?vue&type=style&index=0&id=6c34d4d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c34d4d9",
  null
  
)

export default component.exports